/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialGroupsWeb = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var SocialGroupsWeb = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        AutoInvitesService: function () {
            return function (headers) {
                var service = {
                    deleteAutoInvite: function (deleteAutoInviteRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v2/auto-invites/{invite_id}', deleteAutoInviteRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['invite', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getAutoInvite: function (getAutoInviteRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/auto-invites/{invite_id}', getAutoInviteRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['invite', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    joinWithAutoInvite: function (joinWithAutoInviteRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/auto-invites/join', joinWithAutoInviteRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'joinedDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listAutoInvites: function (listAutoInvitesRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/groups/{group_id}/auto-invites', listAutoInvitesRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['invites', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.deleteAutoInvite.__http_method = 'DELETE';
                service.deleteAutoInvite.__http_url = '/v2/auto-invites/{invite_id}';
                service.getAutoInvite.__http_method = 'GET';
                service.getAutoInvite.__http_url = '/v2/auto-invites/{invite_id}';
                service.joinWithAutoInvite.__http_method = 'POST';
                service.joinWithAutoInvite.__http_url = '/v2/auto-invites/join';
                service.listAutoInvites.__http_method = 'GET';
                service.listAutoInvites.__http_url = '/v2/groups/{group_id}/auto-invites';
                return service;
            };
        },
        CentralFeedService: function () {
            return function (headers) {
                var service = {
                    getFeed: function (getFeedRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/central-feed', getFeedRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'updatedAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'comments', 'comments', 'reactions', 'usersReactions', 'userReactions', 'reactionTime'] },
                                        {
                                            typeName: 'google.protobuf.Timestamp',
                                            pathInPayload: ['feedItems', 'comments', 'comments', 'replies', 'comments', 'reactions', 'usersReactions', 'userReactions', 'reactionTime'],
                                        },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'comments', 'comments', 'replies', 'comments', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'comments', 'comments', 'replies', 'comments', 'updatedAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'comments', 'comments', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'comments', 'comments', 'updatedAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'latestComments', 'comments', 'reactions', 'usersReactions', 'userReactions', 'reactionTime'] },
                                        {
                                            typeName: 'google.protobuf.Timestamp',
                                            pathInPayload: ['feedItems', 'latestComments', 'comments', 'replies', 'comments', 'reactions', 'usersReactions', 'userReactions', 'reactionTime'],
                                        },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'latestComments', 'comments', 'replies', 'comments', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'latestComments', 'comments', 'replies', 'comments', 'updatedAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'latestComments', 'comments', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'latestComments', 'comments', 'updatedAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'reactions', 'usersReactions', 'userReactions', 'reactionTime'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'reactions', 'reactionsSummary', 'latestReactions', 'reactionTime'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'pin', 'since'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'contentPreviews', 'openGraph', 'typeArticle', 'publishedTime'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'contentPreviews', 'openGraph', 'typeArticle', 'modifiedTime'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['feedItems', 'contentPreviews', 'openGraph', 'typeArticle', 'expirationTime'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getFeedSettings: function (getFeedSettingsRequest) {
                        return httpClient.invoke('GET', '/v2/central-feed/settings', getFeedSettingsRequest, headers);
                    },
                    updateFeedSettings: function (updateFeedSettingsRequest) {
                        return httpClient.invoke('POST', '/v2/central-feed/settings', updateFeedSettingsRequest, headers);
                    },
                };
                service.getFeed.__http_method = 'GET';
                service.getFeed.__http_url = '/v2/central-feed';
                service.getFeedSettings.__http_method = 'GET';
                service.getFeedSettings.__http_url = '/v2/central-feed/settings';
                service.updateFeedSettings.__http_method = 'POST';
                service.updateFeedSettings.__http_url = '/v2/central-feed/settings';
                return service;
            };
        },
        ContextTokensService: function () {
            return function (headers) {
                var service = {
                    getContextToken: function (getIssuedContextTokenRequest) {
                        return httpClient.invoke('POST', '/v2/context-token/{group_id}', getIssuedContextTokenRequest, headers);
                    },
                    getContextTokenRequest: function (getContextTokenRequestRequest) {
                        return httpClient.invoke('POST', '/v2/context-token-request/{group_id}', getContextTokenRequestRequest, headers);
                    },
                    listContextTokenRequests: function (listContextTokenRequestsRequest) {
                        return httpClient.invoke('POST', '/v2/context-token-request', listContextTokenRequestsRequest, headers);
                    },
                };
                service.getContextToken.__http_method = 'POST';
                service.getContextToken.__http_url = '/v2/context-token/{group_id}';
                service.getContextTokenRequest.__http_method = 'POST';
                service.getContextTokenRequest.__http_url = '/v2/context-token-request/{group_id}';
                service.listContextTokenRequests.__http_method = 'POST';
                service.listContextTokenRequests.__http_url = '/v2/context-token-request';
                return service;
            };
        },
        GroupMembersService: function () {
            return function (headers) {
                var service = {
                    addGroupMembers: function (addGroupMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/members', addGroupMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    joinGroup: function (joinRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/join', joinRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'joinedDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    leaveGroup: function (leaveRequest) { return httpClient.invoke('POST', '/v2/groups/{group_id}/leave', leaveRequest, headers); },
                    listGroupMembers: function (v2ListGroupMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/groups/{group_id}/members', v2ListGroupMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listMemberships: function (listMembershipsRequest) {
                        return httpClient.invoke('GET', '/v2/members/{site_member_id}/memberships', listMembershipsRequest, headers);
                    },
                    queryGroupMembers: function (v2QueryGroupMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/members/query', v2QueryGroupMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryMemberships: function (queryMembershipsRequest) {
                        return httpClient.invoke('POST', '/v2/members/{member_id}/memberships/query', queryMembershipsRequest, headers);
                    },
                    queryNonGroupMembers: function (v2QueryNonGroupMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/members/non_group', v2QueryNonGroupMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    removeGroupMembers: function (removeGroupMembersRequest) {
                        return httpClient.invoke('DELETE', '/v2/groups/{group_id}/members', removeGroupMembersRequest, headers);
                    },
                };
                service.addGroupMembers.__http_method = 'POST';
                service.addGroupMembers.__http_url = '/v2/groups/{group_id}/members';
                service.joinGroup.__http_method = 'POST';
                service.joinGroup.__http_url = '/v2/groups/{group_id}/join';
                service.leaveGroup.__http_method = 'POST';
                service.leaveGroup.__http_url = '/v2/groups/{group_id}/leave';
                service.listGroupMembers.__http_method = 'GET';
                service.listGroupMembers.__http_url = '/v2/groups/{group_id}/members';
                service.listMemberships.__http_method = 'GET';
                service.listMemberships.__http_url = '/v2/members/{site_member_id}/memberships';
                service.queryGroupMembers.__http_method = 'POST';
                service.queryGroupMembers.__http_url = '/v2/groups/{group_id}/members/query';
                service.queryMemberships.__http_method = 'POST';
                service.queryMemberships.__http_url = '/v2/members/{member_id}/memberships/query';
                service.queryNonGroupMembers.__http_method = 'POST';
                service.queryNonGroupMembers.__http_url = '/v2/groups/{group_id}/members/non_group';
                service.removeGroupMembers.__http_method = 'DELETE';
                service.removeGroupMembers.__http_url = '/v2/groups/{group_id}/members';
                return service;
            };
        },
        GroupRequestsService: function () {
            return function (headers) {
                var service = {
                    approveGroupRequests: function (approveGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/group-requests/approve', approveGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    cancelGroupRequest: function (cancelGroupRequestRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v2/group-requests/{group_request_id}', cancelGroupRequestRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listGroupRequests: function (listGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/group-requests', listGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequests', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequests', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequests', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryGroupRequests: function (queryGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/group-requests/query', queryGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequests', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequests', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequests', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    rejectGroupRequests: function (rejectGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/group-requests/reject', rejectGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    submitGroupRequest: function (submitGroupRequestRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(submitGroupRequestRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups-requests', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupRequest', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.approveGroupRequests.__http_method = 'POST';
                service.approveGroupRequests.__http_url = '/v2/group-requests/approve';
                service.cancelGroupRequest.__http_method = 'DELETE';
                service.cancelGroupRequest.__http_url = '/v2/group-requests/{group_request_id}';
                service.listGroupRequests.__http_method = 'GET';
                service.listGroupRequests.__http_url = '/v2/group-requests';
                service.queryGroupRequests.__http_method = 'POST';
                service.queryGroupRequests.__http_url = '/v2/group-requests/query';
                service.rejectGroupRequests.__http_method = 'POST';
                service.rejectGroupRequests.__http_url = '/v2/group-requests/reject';
                service.submitGroupRequest.__http_method = 'POST';
                service.submitGroupRequest.__http_url = '/v2/groups-requests';
                return service;
            };
        },
        GroupRolesService: function () {
            return function (headers) {
                var service = {
                    assignRole: function (assignRoleRequest) {
                        return httpClient.invoke('POST', '/v2/groups/{group_id}/roles/assign', assignRoleRequest, headers);
                    },
                    unassignRole: function (unassignRoleRequest) {
                        return httpClient.invoke('POST', '/v2/groups/{group_id}/roles/unassign', unassignRoleRequest, headers);
                    },
                };
                service.assignRole.__http_method = 'POST';
                service.assignRole.__http_url = '/v2/groups/{group_id}/roles/assign';
                service.unassignRole.__http_method = 'POST';
                service.unassignRole.__http_url = '/v2/groups/{group_id}/roles/unassign';
                return service;
            };
        },
        GroupRulesService: function () {
            return function (headers) {
                var service = {
                    createOrReplaceAllRules: function (createOrReplaceAllRulesRequest) {
                        return httpClient.invoke('PUT', '/v2/rules/{group_id}', createOrReplaceAllRulesRequest, headers);
                    },
                    listRules: function (listRulesRequest) { return httpClient.invoke('GET', '/v2/rules/{group_id}', listRulesRequest, headers); },
                    listTemplates: function (any) { return httpClient.invoke('GET', '/v2/rules/templates', any, headers); },
                };
                service.createOrReplaceAllRules.__http_method = 'PUT';
                service.createOrReplaceAllRules.__http_url = '/v2/rules/{group_id}';
                service.listRules.__http_method = 'GET';
                service.listRules.__http_url = '/v2/rules/{group_id}';
                service.listTemplates.__http_method = 'GET';
                service.listTemplates.__http_url = '/v2/rules/templates';
                return service;
            };
        },
        GroupSettingsService: function () {
            return function (headers) {
                var service = {
                    getSettings: function (getSettingsRequest) { return httpClient.invoke('GET', '/v2/settings', getSettingsRequest, headers); },
                    updateSettings: function (updateSettingsRequest) {
                        return httpClient.invoke('PATCH', '/v2/settings', updateSettingsRequest, headers);
                    },
                };
                service.getSettings.__http_method = 'GET';
                service.getSettings.__http_url = '/v2/settings';
                service.updateSettings.__http_method = 'PATCH';
                service.updateSettings.__http_url = '/v2/settings';
                return service;
            };
        },
        GroupsInternalService: function () {
            return function (headers) {
                var service = {
                    getGroupsReady: function (getGroupsReadyRequest) {
                        return httpClient.invoke('GET', '/v2/groups/ready', getGroupsReadyRequest, headers);
                    },
                };
                service.getGroupsReady.__http_method = 'GET';
                service.getGroupsReady.__http_url = '/v2/groups/ready';
                return service;
            };
        },
        GroupsService: function () {
            return function (headers) {
                var service = {
                    createGroup: function (v2CreateGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(v2CreateGroupRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteGroup: function (v2DeleteGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v2/groups/{group_id}', v2DeleteGroupRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getGroup: function (v2GetGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/groups/{group_id}', v2GetGroupRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getGroupBySlug: function (getGroupBySlugRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/groups/slugs/{slug}', getGroupBySlugRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listGroups: function (v2ListGroupsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/groups', v2ListGroupsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryGroups: function (queryGroupsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/query', queryGroupsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryGroupsWithRelationships: function (queryGroupsWithRelationshipsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups-with-relationships/query', queryGroupsWithRelationshipsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupWithRelationship', 'group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupWithRelationship', 'group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groupWithRelationship', 'group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateGroup: function (v2UpdateGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(v2UpdateGroupRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PATCH', '/v2/groups/{group.id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.createGroup.__http_method = 'POST';
                service.createGroup.__http_url = '/v2/groups';
                service.deleteGroup.__http_method = 'DELETE';
                service.deleteGroup.__http_url = '/v2/groups/{group_id}';
                service.getGroup.__http_method = 'GET';
                service.getGroup.__http_url = '/v2/groups/{group_id}';
                service.getGroupBySlug.__http_method = 'GET';
                service.getGroupBySlug.__http_url = '/v2/groups/slugs/{slug}';
                service.listGroups.__http_method = 'GET';
                service.listGroups.__http_url = '/v2/groups';
                service.queryGroups.__http_method = 'POST';
                service.queryGroups.__http_url = '/v2/groups/query';
                service.queryGroupsWithRelationships.__http_method = 'POST';
                service.queryGroupsWithRelationships.__http_url = '/v2/groups-with-relationships/query';
                service.updateGroup.__http_method = 'PATCH';
                service.updateGroup.__http_url = '/v2/groups/{group.id}';
                return service;
            };
        },
        GroupUpdatesService: function () {
            return function (headers) {
                var service = {
                    resetUpdatesCounter: function (resetUpdatesCounterRequest) {
                        return httpClient.invoke('POST', '/v2/{group_id}/updates', resetUpdatesCounterRequest, headers);
                    },
                };
                service.resetUpdatesCounter.__http_method = 'POST';
                service.resetUpdatesCounter.__http_url = '/v2/{group_id}/updates';
                return service;
            };
        },
        JoinGroupRequestsService: function () {
            return function (headers) {
                var service = {
                    approveJoinGroupRequests: function (approveJoinGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/join-requests/approve', approveJoinGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['joinGroupRequests', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    cancelJoinGroupRequest: function (cancelJoinGroupRequestRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v2/groups/{group_id}/join-requests', cancelJoinGroupRequestRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['joinGroupRequest', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listJoinGroupRequests: function (listJoinGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v2/groups/{group_id}/join-requests', listJoinGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['joinGroupRequests', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryJoinGroupRequests: function (queryJoinGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/join-requests/query', queryJoinGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['joinGroupRequests', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    rejectJoinGroupRequests: function (rejectJoinGroupRequestsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/join-requests/reject', rejectJoinGroupRequestsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['joinGroupRequests', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    submitJoinGroupRequest: function (submitJoinGroupRequestRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v2/groups/{group_id}/join-requests', submitJoinGroupRequestRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['joinGroupRequest', 'createdDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.approveJoinGroupRequests.__http_method = 'POST';
                service.approveJoinGroupRequests.__http_url = '/v2/groups/{group_id}/join-requests/approve';
                service.cancelJoinGroupRequest.__http_method = 'DELETE';
                service.cancelJoinGroupRequest.__http_url = '/v2/groups/{group_id}/join-requests';
                service.listJoinGroupRequests.__http_method = 'GET';
                service.listJoinGroupRequests.__http_url = '/v2/groups/{group_id}/join-requests';
                service.queryJoinGroupRequests.__http_method = 'POST';
                service.queryJoinGroupRequests.__http_url = '/v2/groups/{group_id}/join-requests/query';
                service.rejectJoinGroupRequests.__http_method = 'POST';
                service.rejectJoinGroupRequests.__http_url = '/v2/groups/{group_id}/join-requests/reject';
                service.submitJoinGroupRequest.__http_method = 'POST';
                service.submitJoinGroupRequest.__http_url = '/v2/groups/{group_id}/join-requests';
                return service;
            };
        },
        MembershipQuestionsService: function () {
            return function (headers) {
                var service = {
                    createOrReplaceAllMembershipQuestions: function (createOrReplaceAllMembershipQuestionsRequest) {
                        return httpClient.invoke('PUT', '/v2/membership-questions/{group_id}', createOrReplaceAllMembershipQuestionsRequest, headers);
                    },
                    listAnswers: function (listAnswersRequest) {
                        return httpClient.invoke('POST', '/v2/membership-questions/{group_id}/answers', listAnswersRequest, headers);
                    },
                    listMembershipQuestions: function (v2ListMembershipQuestionsRequest) {
                        return httpClient.invoke('GET', '/v2/membership-questions/{group_id}', v2ListMembershipQuestionsRequest, headers);
                    },
                };
                service.createOrReplaceAllMembershipQuestions.__http_method = 'PUT';
                service.createOrReplaceAllMembershipQuestions.__http_url = '/v2/membership-questions/{group_id}';
                service.listAnswers.__http_method = 'POST';
                service.listAnswers.__http_url = '/v2/membership-questions/{group_id}/answers';
                service.listMembershipQuestions.__http_method = 'GET';
                service.listMembershipQuestions.__http_url = '/v2/membership-questions/{group_id}';
                return service;
            };
        },
        SocialGroupsActivityService: function () {
            return function (headers) {
                var service = {
                    getActivityStats: function (getActivityStatsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups/{group_id}/activity/stats', getActivityStatsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['recentActivityDate'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.getActivityStats.__http_method = 'GET';
                service.getActivityStats.__http_url = '/api/v1/groups/{group_id}/activity/stats';
                return service;
            };
        },
        SocialGroupsAppsService: function () {
            return function (headers) {
                var service = {
                    configureApps: function (configureAppsRequest) { return httpClient.invoke('POST', '/api/v1/groups/{group_id}/apps', configureAppsRequest, headers); },
                    listApps: function (listAppsRequest) { return httpClient.invoke('GET', '/api/v1/groups/{group_id}/apps', listAppsRequest, headers); },
                    removeApp: function (removeAppRequest) { return httpClient.invoke('DELETE', '/api/v1/groups/{group_id}/apps/{app_key}', removeAppRequest, headers); },
                };
                service.configureApps.__http_method = 'POST';
                service.configureApps.__http_url = '/api/v1/groups/{group_id}/apps';
                service.listApps.__http_method = 'GET';
                service.listApps.__http_url = '/api/v1/groups/{group_id}/apps';
                service.removeApp.__http_method = 'DELETE';
                service.removeApp.__http_url = '/api/v1/groups/{group_id}/apps/{app_key}';
                return service;
            };
        },
        SocialGroupsEventsMappingService: function () {
            return function (headers) {
                var service = {
                    addEvents: function (addRequest) { return httpClient.invoke('POST', '/api/v1/groups/{group_id}/events/add', addRequest, headers); },
                    listEvents: function (getRequest) { return httpClient.invoke('GET', '/api/v1/groups/{group_id}/events', getRequest, headers); },
                    listGroupsByEventId: function (listGroupsByEventIdRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/queryByEventId', listGroupsByEventIdRequest, headers);
                    },
                    listGroupsByEventIds: function (listGroupsByEventIdsRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/queryByEventIds', listGroupsByEventIdsRequest, headers);
                    },
                    removeEvents: function (removeRequest) { return httpClient.invoke('POST', '/api/v1/groups/{group_id}/events/remove', removeRequest, headers); },
                };
                service.addEvents.__http_method = 'POST';
                service.addEvents.__http_url = '/api/v1/groups/{group_id}/events/add';
                service.listEvents.__http_method = 'GET';
                service.listEvents.__http_url = '/api/v1/groups/{group_id}/events';
                service.listGroupsByEventId.__http_method = 'GET';
                service.listGroupsByEventId.__http_url = '/api/v1/groups/queryByEventId';
                service.listGroupsByEventIds.__http_method = 'GET';
                service.listGroupsByEventIds.__http_url = '/api/v1/groups/queryByEventIds';
                service.removeEvents.__http_method = 'POST';
                service.removeEvents.__http_url = '/api/v1/groups/{group_id}/events/remove';
                return service;
            };
        },
        SocialGroupsFeedIntegrationService: function () {
            return function (headers) {
                var service = {
                    getTokens: function (getFeedTokensRequest) {
                        return httpClient.invoke('POST', '/api/v1/integration/feed/tokens', getFeedTokensRequest, headers);
                    },
                };
                service.getTokens.__http_method = 'POST';
                service.getTokens.__http_url = '/api/v1/integration/feed/tokens';
                return service;
            };
        },
        SocialGroupsGdprService: function () {
            return function (headers) {
                var service = {
                    uou: function (gdprUouRequest) { return httpClient.invoke('POST', '/api/v1/groups/internal/gdpr/{request_id}/uou', gdprUouRequest, headers); },
                    user: function (gdprUserRequest) { return httpClient.invoke('POST', '/api/v1/groups/internal/gdpr/{request_id}/user', gdprUserRequest, headers); },
                };
                service.uou.__http_method = 'POST';
                service.uou.__http_url = '/api/v1/groups/internal/gdpr/{request_id}/uou';
                service.user.__http_method = 'POST';
                service.user.__http_url = '/api/v1/groups/internal/gdpr/{request_id}/user';
                return service;
            };
        },
        SocialGroupsInternalService: function () {
            return function (headers) {
                var service = {
                    getDefaultGroup: function (any) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/internal/groups/default', any, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getDefaultPost: function (any) { return httpClient.invoke('GET', '/api/v1/internal/groups/default/post', any, headers); },
                };
                service.getDefaultGroup.__http_method = 'GET';
                service.getDefaultGroup.__http_url = '/api/v1/internal/groups/default';
                service.getDefaultPost.__http_method = 'GET';
                service.getDefaultPost.__http_url = '/api/v1/internal/groups/default/post';
                return service;
            };
        },
        SocialGroupsInviteService: function () {
            return function (headers) {
                var service = {
                    batchInviteByEmail: function (batchEmailInviteRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/invites/email-batch', batchEmailInviteRequest, headers);
                    },
                    inviteByEmail: function (emailInviteRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/invites/email', emailInviteRequest, headers);
                    },
                    inviteLink: function (emailInviteLinkRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/{group_id}/invites/email', emailInviteLinkRequest, headers);
                    },
                };
                service.batchInviteByEmail.__http_method = 'POST';
                service.batchInviteByEmail.__http_url = '/api/v1/groups/{group_id}/invites/email-batch';
                service.inviteByEmail.__http_method = 'POST';
                service.inviteByEmail.__http_url = '/api/v1/groups/{group_id}/invites/email';
                service.inviteLink.__http_method = 'GET';
                service.inviteLink.__http_url = '/api/v1/groups/{group_id}/invites/email';
                return service;
            };
        },
        SocialGroupsMediaIntegrationService: function () {
            return function (headers) {
                var service = {
                    getToken: function (any) { return httpClient.invoke('GET', '/api/v1/integration/media/token', any, headers); },
                };
                service.getToken.__http_method = 'GET';
                service.getToken.__http_url = '/api/v1/integration/media/token';
                return service;
            };
        },
        SocialGroupsMembershipService: function () {
            return function (headers) {
                var service = {
                    addMembersToGroup: function (addMembersToGroupRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/add', addMembersToGroupRequest, headers);
                    },
                    addNonGroupMembers: function (addNonGroupMembersRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/non_group/add', addNonGroupMembersRequest, headers);
                    },
                    approveGroupMembership: function (approveGroupMemershipRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/{site_member_id}/approve', approveGroupMemershipRequest, headers);
                    },
                    bulkApproveGroupMembership: function (bulkApproveGroupMembershipRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/approve', bulkApproveGroupMembershipRequest, headers);
                    },
                    bulkRejectGroupMembership: function (bulkRejectGroupMembershipRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/reject', bulkRejectGroupMembershipRequest, headers);
                    },
                    countNewMembers: function (countNewMembersRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/count', countNewMembersRequest, headers);
                    },
                    countNonGroupMembers: function (countNonGroupMembersRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/{group_id}/members/non_group/count', countNonGroupMembersRequest, headers);
                    },
                    getGroupMember: function (getGroupMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups/{group_id}/members/member/{site_member_id}', getGroupMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'joinedOn'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'requestedMembershipOn'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    joinGroup: function (v1JoinGroupRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/me', v1JoinGroupRequest, headers);
                    },
                    leaveGroup: function (leaveGroupRequest) { return httpClient.invoke('DELETE', '/api/v1/groups/{group_id}/members/me', leaveGroupRequest, headers); },
                    listAllMembers: function (listAllMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups/{group_id}/members/all', listAllMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedOn'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'requestedMembershipOn'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listGroupMembers: function (v1ListGroupMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups/{group_id}/members', v1ListGroupMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedOn'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'requestedMembershipOn'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listMembershipQuestionAnswers: function (listMembershipQuestionAnswersRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/membership-answers', listMembershipQuestionAnswersRequest, headers);
                    },
                    listMembershipQuestions: function (v1ListMembershipQuestionsRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/{group_id}/membership-questions', v1ListMembershipQuestionsRequest, headers);
                    },
                    listPendingMembers: function (listPendingMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups/{group_id}/members/pending', listPendingMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'requestedMembershipOn'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryAllMembers: function (queryAllMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/all', queryAllMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedOn'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'requestedMembershipOn'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryGroupMembers: function (v1QueryGroupMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/v1/groups/{group_id}/members', v1QueryGroupMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'joinedOn'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'requestedMembershipOn'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryNonGroupMembers: function (v1QueryNonGroupMembersRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/non_group', v1QueryNonGroupMembersRequest, headers);
                    },
                    rejectGroupMembership: function (rejectGroupMemershipRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/{site_member_id}/reject', rejectGroupMemershipRequest, headers);
                    },
                    removeMembersFromGroup: function (removeMembersFromGroupRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/remove', removeMembersFromGroupRequest, headers);
                    },
                    saveMembershipQuestions: function (saveMembershipQuestionsRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/membership-questions', saveMembershipQuestionsRequest, headers);
                    },
                    submitRequestToJoin: function (submitRequestToJoinRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/request', submitRequestToJoinRequest, headers);
                    },
                    withdrawRequestToJoin: function (withdrawRequestToJoinRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/groups/{group_id}/members/request', withdrawRequestToJoinRequest, headers);
                    },
                };
                service.addMembersToGroup.__http_method = 'POST';
                service.addMembersToGroup.__http_url = '/api/v1/groups/{group_id}/members/add';
                service.addNonGroupMembers.__http_method = 'POST';
                service.addNonGroupMembers.__http_url = '/api/v1/groups/{group_id}/members/non_group/add';
                service.approveGroupMembership.__http_method = 'POST';
                service.approveGroupMembership.__http_url = '/api/v1/groups/{group_id}/members/{site_member_id}/approve';
                service.bulkApproveGroupMembership.__http_method = 'POST';
                service.bulkApproveGroupMembership.__http_url = '/api/v1/groups/{group_id}/members/approve';
                service.bulkRejectGroupMembership.__http_method = 'POST';
                service.bulkRejectGroupMembership.__http_url = '/api/v1/groups/{group_id}/members/reject';
                service.countNewMembers.__http_method = 'POST';
                service.countNewMembers.__http_url = '/api/v1/groups/{group_id}/members/count';
                service.countNonGroupMembers.__http_method = 'GET';
                service.countNonGroupMembers.__http_url = '/api/v1/groups/{group_id}/members/non_group/count';
                service.getGroupMember.__http_method = 'GET';
                service.getGroupMember.__http_url = '/api/v1/groups/{group_id}/members/member/{site_member_id}';
                service.joinGroup.__http_method = 'POST';
                service.joinGroup.__http_url = '/api/v1/groups/{group_id}/members/me';
                service.leaveGroup.__http_method = 'DELETE';
                service.leaveGroup.__http_url = '/api/v1/groups/{group_id}/members/me';
                service.listAllMembers.__http_method = 'GET';
                service.listAllMembers.__http_url = '/api/v1/groups/{group_id}/members/all';
                service.listGroupMembers.__http_method = 'GET';
                service.listGroupMembers.__http_url = '/api/v1/groups/{group_id}/members';
                service.listMembershipQuestionAnswers.__http_method = 'POST';
                service.listMembershipQuestionAnswers.__http_url = '/api/v1/groups/{group_id}/membership-answers';
                service.listMembershipQuestions.__http_method = 'GET';
                service.listMembershipQuestions.__http_url = '/api/v1/groups/{group_id}/membership-questions';
                service.listPendingMembers.__http_method = 'GET';
                service.listPendingMembers.__http_url = '/api/v1/groups/{group_id}/members/pending';
                service.queryAllMembers.__http_method = 'POST';
                service.queryAllMembers.__http_url = '/api/v1/groups/{group_id}/members/all';
                service.queryGroupMembers.__http_method = 'POST';
                service.queryGroupMembers.__http_url = '/api/v1/groups/{group_id}/members';
                service.queryNonGroupMembers.__http_method = 'POST';
                service.queryNonGroupMembers.__http_url = '/api/v1/groups/{group_id}/members/non_group';
                service.rejectGroupMembership.__http_method = 'POST';
                service.rejectGroupMembership.__http_url = '/api/v1/groups/{group_id}/members/{site_member_id}/reject';
                service.removeMembersFromGroup.__http_method = 'POST';
                service.removeMembersFromGroup.__http_url = '/api/v1/groups/{group_id}/members/remove';
                service.saveMembershipQuestions.__http_method = 'POST';
                service.saveMembershipQuestions.__http_url = '/api/v1/groups/{group_id}/membership-questions';
                service.submitRequestToJoin.__http_method = 'POST';
                service.submitRequestToJoin.__http_url = '/api/v1/groups/{group_id}/members/request';
                service.withdrawRequestToJoin.__http_method = 'DELETE';
                service.withdrawRequestToJoin.__http_url = '/api/v1/groups/{group_id}/members/request';
                return service;
            };
        },
        SocialGroupsMigrationService: function () {
            return function (headers) {
                var service = {
                    migrate: function (migrationRequest) { return httpClient.invoke('POST', '/api/v1/groups/migrate', migrationRequest, headers); },
                };
                service.migrate.__http_method = 'POST';
                service.migrate.__http_url = '/api/v1/groups/migrate';
                return service;
            };
        },
        SocialGroupsNotificationSettingsService: function () {
            return function (headers) {
                var service = {
                    getNotificationSettings: function (getNotificationSettingsRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/{group_id}/notification-settings', getNotificationSettingsRequest, headers);
                    },
                    updateNotificationSettings: function (updateNotificationSettingsRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/notification-settings', updateNotificationSettingsRequest, headers);
                    },
                };
                service.getNotificationSettings.__http_method = 'GET';
                service.getNotificationSettings.__http_url = '/api/v1/groups/{group_id}/notification-settings';
                service.updateNotificationSettings.__http_method = 'POST';
                service.updateNotificationSettings.__http_url = '/api/v1/groups/{group_id}/notification-settings';
                return service;
            };
        },
        SocialGroupsNotificationTriggerService: function () {
            return function (headers) {
                var service = {
                    engageToUseGroups: function (engageToInstallGroupsRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/internal/engage-to-use-groups', engageToInstallGroupsRequest, headers);
                    },
                    scheduleEmailDigest: function (emailDigestScheduleRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['scheduleTime'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(emailDigestScheduleRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/api/v1/groups/internal/schedule-email-digest', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                    trigger: function (notificationTriggerRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/internal/notifications-trigger', notificationTriggerRequest, headers);
                    },
                    triggerRemindersToCreateGroup: function (triggerRemindersToCreateGroupRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/internal/trigger-reminders-to-create-group', triggerRemindersToCreateGroupRequest, headers);
                    },
                };
                service.engageToUseGroups.__http_method = 'POST';
                service.engageToUseGroups.__http_url = '/api/v1/groups/internal/engage-to-use-groups';
                service.scheduleEmailDigest.__http_method = 'POST';
                service.scheduleEmailDigest.__http_url = '/api/v1/groups/internal/schedule-email-digest';
                service.trigger.__http_method = 'POST';
                service.trigger.__http_url = '/api/v1/groups/internal/notifications-trigger';
                service.triggerRemindersToCreateGroup.__http_method = 'POST';
                service.triggerRemindersToCreateGroup.__http_url = '/api/v1/groups/internal/trigger-reminders-to-create-group';
                return service;
            };
        },
        SocialGroupsPageRoutingService: function () {
            return function (headers) {
                var service = {
                    getRouting: function (getPagesRoutingRequest) {
                        return httpClient.invoke('POST', '/api/v1/integration/pages', getPagesRoutingRequest, headers);
                    },
                };
                service.getRouting.__http_method = 'POST';
                service.getRouting.__http_url = '/api/v1/integration/pages';
                return service;
            };
        },
        SocialGroupsRolesService: function () {
            return function (headers) {
                var service = {
                    removeMemberRole: function (removeMemberRoleRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/groups/{group_id}/members/{site_member_id}/role', removeMemberRoleRequest, headers);
                    },
                    setMemberRole: function (setMemberRoleRequest) {
                        return httpClient.invoke('POST', '/api/v1/groups/{group_id}/members/{site_member_id}/role', setMemberRoleRequest, headers);
                    },
                };
                service.removeMemberRole.__http_method = 'DELETE';
                service.removeMemberRole.__http_url = '/api/v1/groups/{group_id}/members/{site_member_id}/role';
                service.setMemberRole.__http_method = 'POST';
                service.setMemberRole.__http_url = '/api/v1/groups/{group_id}/members/{site_member_id}/role';
                return service;
            };
        },
        SocialGroupsRulesService: function () {
            return function (headers) {
                var service = {
                    getGroupRules: function (getRulesRequest) { return httpClient.invoke('GET', '/api/v1/groups/{group_id}/rules', getRulesRequest, headers); },
                    getRules: function (any) { return httpClient.invoke('GET', '/api/v1/groups/default/rules', any, headers); },
                    saveGroupRules: function (saveRulesRequest) { return httpClient.invoke('POST', '/api/v1/groups/{group_id}/rules', saveRulesRequest, headers); },
                };
                service.getGroupRules.__http_method = 'GET';
                service.getGroupRules.__http_url = '/api/v1/groups/{group_id}/rules';
                service.getRules.__http_method = 'GET';
                service.getRules.__http_url = '/api/v1/groups/default/rules';
                service.saveGroupRules.__http_method = 'POST';
                service.saveGroupRules.__http_url = '/api/v1/groups/{group_id}/rules';
                return service;
            };
        },
        SocialGroupsService: function () {
            return function (headers) {
                var service = {
                    archiveGroup: function (archiveGroupRequest) { return httpClient.invoke('POST', '/api/v1/groups/{group_id}/archive', archiveGroupRequest, headers); },
                    createGroup: function (v1CreateGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/v1/groups', v1CreateGroupRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteGroup: function (v1DeleteGroupRequest) { return httpClient.invoke('DELETE', '/api/v1/groups/{group_id}', v1DeleteGroupRequest, headers); },
                    getGroup: function (v1GetGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups/{group_id}', v1GetGroupRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['group', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getGroupsInstanceSettings: function (getGroupsInstanceSettingsRequest) {
                        return httpClient.invoke('GET', '/api/v1/groups/settings', getGroupsInstanceSettingsRequest, headers);
                    },
                    listGroups: function (v1ListGroupsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/v1/groups', v1ListGroupsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['groups', 'recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateGroup: function (v1UpdateGroupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.FieldMaskArray', pathInPayload: ['fieldMask'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(v1UpdateGroupRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PATCH', '/api/v1/groups/{group_id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['recentActivityDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateGroupClientData: function (updateGroupClientDataRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/groups/{group_id}/client_data', updateGroupClientDataRequest, headers);
                    },
                    updateGroupsInstanceSettings: function (updateGroupsInstanceSettingsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.FieldMaskArray', pathInPayload: ['fieldMask'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateGroupsInstanceSettingsRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PATCH', '/api/v1/groups/settings', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                };
                service.archiveGroup.__http_method = 'POST';
                service.archiveGroup.__http_url = '/api/v1/groups/{group_id}/archive';
                service.createGroup.__http_method = 'POST';
                service.createGroup.__http_url = '/api/v1/groups';
                service.deleteGroup.__http_method = 'DELETE';
                service.deleteGroup.__http_url = '/api/v1/groups/{group_id}';
                service.getGroup.__http_method = 'GET';
                service.getGroup.__http_url = '/api/v1/groups/{group_id}';
                service.getGroupsInstanceSettings.__http_method = 'GET';
                service.getGroupsInstanceSettings.__http_url = '/api/v1/groups/settings';
                service.listGroups.__http_method = 'GET';
                service.listGroups.__http_url = '/api/v1/groups';
                service.updateGroup.__http_method = 'PATCH';
                service.updateGroup.__http_url = '/api/v1/groups/{group_id}';
                service.updateGroupClientData.__http_method = 'PATCH';
                service.updateGroupClientData.__http_url = '/api/v1/groups/{group_id}/client_data';
                service.updateGroupsInstanceSettings.__http_method = 'PATCH';
                service.updateGroupsInstanceSettings.__http_url = '/api/v1/groups/settings';
                return service;
            };
        },
        SocialGroupsTasksService: function () {
            return function (headers) {
                var service = {
                    triggerEmailDigest: function (any) { return httpClient.invoke('POST', '/tasks/trigger-email-digest', any, headers); },
                    triggerMembersGroupsRetry: function (any) { return httpClient.invoke('POST', '/tasks/trigger-members-groups-retry', any, headers); },
                };
                service.triggerEmailDigest.__http_method = 'POST';
                service.triggerEmailDigest.__http_url = '/tasks/trigger-email-digest';
                service.triggerMembersGroupsRetry.__http_method = 'POST';
                service.triggerMembersGroupsRetry.__http_url = '/tasks/trigger-members-groups-retry';
                return service;
            };
        },
        TpaSiteStructureService: function () {
            return function (headers) {
                var service = {
                    getTpaSiteStructure: function (tpaSiteStructureRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/site-structure', tpaSiteStructureRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'media', 'image', 'urlExpirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'media', 'video', 'thumbnail', 'urlExpirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'media', 'document', 'urlExpirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'image', 'urlExpirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'video', 'resolutions', 'poster', 'urlExpirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['results', 'video', 'resolutions', 'urlExpirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.getTpaSiteStructure.__http_method = 'POST';
                service.getTpaSiteStructure.__http_url = '/v1/site-structure';
                return service;
            };
        },
    };
};
exports.SocialGroupsWeb = SocialGroupsWeb;
exports.SocialGroupsWeb.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map